import { SUB_ROUTES } from "../TabMenu/TabMenu.constants";

export function isAssetPageTabItem(pathname: string) {
  return SUB_ROUTES.some((tab) => pathname.includes(`/${tab}`));
}

export function shouldHideTabMenu(pathname: string) {
  return ["/evaluation/edit", "/evaluation/new"].some((route) =>
    pathname.includes(route)
  );
}

export function isEvaluationRoute(pathname: string) {
  return pathname.includes("/evaluation");
}
